'use client'
import {
  context_default
} from "./chunk-V3JSSRKS.mjs";

// src/context/config/useConfig.ts
import { useContext } from "react";
var useConfig = () => {
  const context = useContext(context_default);
  if (!context) {
    throw new Error("useConfig must be used within a ConfigProvider");
  }
  return context;
};
var useConfig_default = useConfig;

export {
  useConfig,
  useConfig_default
};
//# sourceMappingURL=chunk-7WWZDHPB.mjs.map